import { codeBlockNodeWithFixedToDOM } from './nodeviews/codeBlockNodeWithToDOMFixed';
import { createPlugin } from './pm-plugins/main';
export var codeBlockAdvancedPlugin = function codeBlockAdvancedPlugin(_ref) {
  var api = _ref.api,
    config = _ref.config;
  return {
    name: 'codeBlockAdvanced',
    nodes: function nodes() {
      return [{
        name: 'codeBlock',
        node: codeBlockNodeWithFixedToDOM()
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'codeBlockAdvancedPlugin',
        plugin: function plugin() {
          var _config$extensions;
          return createPlugin({
            api: api,
            extensions: (_config$extensions = config === null || config === void 0 ? void 0 : config.extensions) !== null && _config$extensions !== void 0 ? _config$extensions : []
          });
        }
      }];
    }
  };
};